import { types } from 'mobx-state-tree'

const Charge = types
    .model('Charge', {
        charge_number: types.optional(types.string, ""),
        disposition_sentence: types.optional(types.string, ""),
        raw: types.optional(types.string, ""),
    })


export const Defendant = types
    .model('Defendant', {
        Name: types.optional(types.string, ""),
        defendent_name: types.optional(types.string, ""),
        "Birth Year": types.string,
    })
export const Appearance = types
    .model('Appearance', {
        Date: types.optional(types.string, ""),
        Time: types.optional(types.string, ""),
        Court: types.optional(types.string, ""),
        Part: types.optional(types.string, ""),
        date: types.optional(types.string, ""),
        time: types.optional(types.string, ""),
        court: types.optional(types.string, ""),
        part: types.optional(types.string, ""),
    })
export default Charge
